'use client';

import { c as _c } from "react/compiler-runtime";
import Portal from '@components/portal/Portal';
import useMousePosition from '@lib/tools/hooks/useMousePosition';
import cn from 'classnames';
import { useEffect, useState } from 'react';
import SwiperCore from 'swiper';
import { FreeMode, Mousewheel } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import GallerySlideModalInner from '../gallery-slide-modal-inner/GallerySlideModalInner';
import 'swiper/css';
import { handleVisibleHeader } from '@lib/store/slices/ComponentsSlice';
import { useDispatch } from 'react-redux';
import style from './GallerySliderModal.module.scss';
SwiperCore.use([FreeMode, Mousewheel]);
const GallerySliderModal = t0 => {
  const $ = _c(70);
  const {
    architectureClassName,
    swiperActive,
    setSwiperActive,
    sliderArr,
    modalStatus,
    setModalStatus,
    scale,
    setScale,
    scaleValue
  } = t0;
  const [swiper, setSwiper] = useState(null);
  const [cursorStatus, setCursorStatus] = useState(false);
  const [allowTransition, setAllowTransition] = useState(false);
  const {
    x,
    y
  } = useMousePosition();
  const dispatch = useDispatch();
  let t1;
  if ($[0] !== sliderArr.length || $[1] !== swiper || $[2] !== swiperActive) {
    t1 = () => {
      swiper.slideTo(swiperActive <= sliderArr.length - 1 ? swiperActive - 1 : swiperActive, 1000);
    };
    $[0] = sliderArr.length;
    $[1] = swiper;
    $[2] = swiperActive;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handlePrev = t1;
  let t2;
  if ($[4] !== swiper || $[5] !== swiperActive) {
    t2 = () => {
      swiper.slideTo(swiperActive >= 0 ? swiperActive + 1 : swiperActive, 1000);
    };
    $[4] = swiper;
    $[5] = swiperActive;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleNext = t2;
  swiper?.on("slideChange", () => {
    setSwiperActive(swiper.activeIndex);
  });
  let t3;
  let t4;
  if ($[7] !== swiper || $[8] !== swiperActive) {
    t3 = () => {
      if (swiper && swiper.activeIndex !== swiperActive) {
        swiper.slideTo(swiperActive);
      }
    };
    t4 = [swiperActive, swiper];
    $[7] = swiper;
    $[8] = swiperActive;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  useEffect(t3, t4);
  let t5;
  if ($[11] !== dispatch || $[12] !== modalStatus) {
    t5 = () => {
      if (modalStatus === true) {
        dispatch(handleVisibleHeader(false));
        setCursorStatus(true);
      } else {
        dispatch(handleVisibleHeader(true));
        setCursorStatus(false);
      }
      return () => dispatch(handleVisibleHeader(true));
    };
    $[11] = dispatch;
    $[12] = modalStatus;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== modalStatus) {
    t6 = [modalStatus];
    $[14] = modalStatus;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  useEffect(t5, t6);
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = event => {
      const overControls = Boolean(event.target.closest(`.${style.nav}, .${style.close}`));
      setCursorStatus(!overControls);
    };
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const handleModalMouseOver = t7;
  const t8 = !modalStatus;
  let t9;
  if ($[17] !== architectureClassName || $[18] !== t8) {
    t9 = cn(style.content, {
      [style.contentHidden]: t8
    }, architectureClassName ? architectureClassName : "");
    $[17] = architectureClassName;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== swiperActive) {
    t10 = instance => {
      instance.slideTo(swiperActive, 0);
      setSwiper(instance);
      requestAnimationFrame(() => setAllowTransition(true));
    };
    $[20] = swiperActive;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== allowTransition) {
    t11 = cn("gallery_swiper_modal", style.swiper, {
      [style.swiperAnimated]: allowTransition
    });
    $[22] = allowTransition;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== setModalStatus) {
    t12 = () => setModalStatus(false);
    $[24] = setModalStatus;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 1.35529L1.35547 16.9999" stroke="#1C1C1C" strokeWidth="2" strokeLinecap="round" /><path d="M16.6444 16.6446L0.999901 0.999999" stroke="#1C1C1C" strokeWidth="2" strokeLinecap="round" /></svg>;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t12) {
    t14 = <button className={style.close} onClick={t12}>{t13}</button>;
    $[27] = t12;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== cursorStatus || $[30] !== scale || $[31] !== x || $[32] !== y) {
    t15 = cursorStatus === true && <div className={style.cursorImg} style={{
      left: x,
      top: y
    }}>{scale > 1.1 ? <svg width="85" height="85" viewBox="0 0 85 85" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="42.5" cy="42.5" r="41.82" stroke="white" strokeWidth="1.36" /><path d="M37.3999 43.0663H48.7332" stroke="white" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" /></svg> : <svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="43" cy="43" r="41.82" stroke="white" strokeWidth="1.36" /><path d="M37.9 43.5663H49.2334" stroke="white" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" /><path d="M43.5667 49.2329V37.8996" stroke="white" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" /></svg>}</div>;
    $[29] = cursorStatus;
    $[30] = scale;
    $[31] = x;
    $[32] = y;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== cursorStatus || $[35] !== scale || $[36] !== scaleValue || $[37] !== setScale || $[38] !== sliderArr) {
    let t17;
    if ($[40] !== cursorStatus || $[41] !== scale || $[42] !== scaleValue || $[43] !== setScale) {
      t17 = url => <SwiperSlide key={url} className={style.swiperSlide}><GallerySlideModalInner url={url} cursorStatus={cursorStatus} scale={scale} setScale={setScale} scaleValue={scaleValue} /></SwiperSlide>;
      $[40] = cursorStatus;
      $[41] = scale;
      $[42] = scaleValue;
      $[43] = setScale;
      $[44] = t17;
    } else {
      t17 = $[44];
    }
    t16 = sliderArr.map(t17);
    $[34] = cursorStatus;
    $[35] = scale;
    $[36] = scaleValue;
    $[37] = setScale;
    $[38] = sliderArr;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.876367 6.49105C0.605168 6.21985 0.605168 5.78015 0.876367 5.50895L5.29578 1.08954C5.56698 0.81834 6.00668 0.81834 6.27788 1.08954C6.54907 1.36073 6.54907 1.80043 6.27788 2.07163L2.34951 6L6.27788 9.92837C6.54907 10.1996 6.54907 10.6393 6.27788 10.9105C6.00668 11.1817 5.56698 11.1817 5.29578 10.9105L0.876367 6.49105ZM14.9443 6.69444L1.36741 6.69445L1.36741 5.30556L14.9443 5.30556L14.9443 6.69444Z" fill="#1C1C1C" /></svg>;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== handlePrev) {
    t18 = <div className="swiper-button-prev gallery_swiper__prev" onClick={handlePrev} role="button" tabIndex="0">{t17}</div>;
    $[46] = handlePrev;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className="swiper-pagination swiper-pagination-fraction swiper-pagination-horizontal" />;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  const t20 = Number(swiperActive) + 1;
  let t21;
  if ($[49] !== sliderArr.length || $[50] !== t20) {
    t21 = <div className={style.nav__counter}>{t20}/{sliderArr.length}</div>;
    $[49] = sliderArr.length;
    $[50] = t20;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.1236 6.49105C14.3948 6.21985 14.3948 5.78015 14.1236 5.50895L9.70422 1.08954C9.43302 0.81834 8.99332 0.81834 8.72212 1.08954C8.45093 1.36073 8.45093 1.80043 8.72212 2.07163L12.6505 6L8.72212 9.92837C8.45093 10.1996 8.45093 10.6393 8.72212 10.9105C8.99332 11.1817 9.43302 11.1817 9.70422 10.9105L14.1236 6.49105ZM0.055664 6.69444L13.6326 6.69445L13.6326 5.30556L0.0556641 5.30556L0.055664 6.69444Z" fill="#1C1C1C" /></svg>;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== handleNext) {
    t23 = <div className="swiper-button-next gallery_swiper__next" onClick={handleNext} role="button" tabIndex="0">{t22}</div>;
    $[53] = handleNext;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  let t24;
  if ($[55] !== t18 || $[56] !== t21 || $[57] !== t23) {
    t24 = <div className={style.nav}>{t18}{t19}{t21}{t23}</div>;
    $[55] = t18;
    $[56] = t21;
    $[57] = t23;
    $[58] = t24;
  } else {
    t24 = $[58];
  }
  let t25;
  if ($[59] !== swiperActive || $[60] !== t10 || $[61] !== t11 || $[62] !== t14 || $[63] !== t15 || $[64] !== t16 || $[65] !== t24) {
    t25 = <Swiper onSwiper={t10} slidesPerView={1} allowTouchMove={false} initialSlide={swiperActive} className={t11}>{t14}{t15}{t16}{t24}</Swiper>;
    $[59] = swiperActive;
    $[60] = t10;
    $[61] = t11;
    $[62] = t14;
    $[63] = t15;
    $[64] = t16;
    $[65] = t24;
    $[66] = t25;
  } else {
    t25 = $[66];
  }
  let t26;
  if ($[67] !== t25 || $[68] !== t9) {
    t26 = <Portal><div className={t9} onMouseOver={handleModalMouseOver}>{t25}</div></Portal>;
    $[67] = t25;
    $[68] = t9;
    $[69] = t26;
  } else {
    t26 = $[69];
  }
  return t26;
};
export default GallerySliderModal;